






import { defineComponent, PropType } from '@vue/composition-api';
import AtoneAlert from '@berlin-front/common/components/atone-components/AtoneAlert';
import AppMessageList from '@berlin-front/common/components/elements/AppMessageList';
import { ALERT_TYPE, AlertType } from '@berlin-front/common/components/atone-components/AtoneAlert/composable';

export default defineComponent({
  name: 'FlashMessage',
  components: {
    AtoneAlert,
    AppMessageList,
  },

  props: {
    alertType: {
      type: String as PropType<AlertType>,
      default: ALERT_TYPE.ERROR,
    },

    messages: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
});
